import { Flex, Typography } from 'antd';
import { FC, memo } from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import { AppModal } from '@/common/components';
import { AppModalControlProps } from '@/common/interfaces';

interface Props {
  controls: AppModalControlProps;
  count: number;
  isDeleting: boolean;
  onConfirm: () => void;
}

export const RedirectsManageDeleteModal: FC<Props> = memo(({ controls, count, isDeleting, onConfirm }) => {
  return (
    <AppModal
      width={ 400 }
      okText="Видалити"
      okButtonProps={{ danger: true, loading: isDeleting }}
      cancelButtonProps={{ disabled: isDeleting }}
      onOk={ onConfirm }
      maskClosable={ !isDeleting }
      closable={ false }
      controls={ controls }
      title={
        <Flex align="center">
          <Typography.Text type="danger">
            <Flex align="center">
              <ExclamationTriangleFill size={ 24 }/>
            </Flex>
          </Typography.Text>
          &nbsp;&nbsp;&nbsp;Видалити { count } редіректів
        </Flex>
      }
    />
  );
});
